"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderContent = exports.ContentSelect = exports.ContentType = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var __1 = require("../../");
exports.ContentType = {
    NONE: 'none',
    ICON: 'Icon',
    BUTTON: 'Button',
    SPINNER: 'Spinner',
    TAG: 'Tag'
};
var ContentSelect = /** @class */ (function () {
    function ContentSelect() {
    }
    ContentSelect.prototype.view = function (_a) {
        var onSelect = _a.attrs.onSelect;
        return (0, mithril_1.default)(__1.Select, {
            fluid: true,
            options: Object.keys(exports.ContentType).map(function (key) { return exports.ContentType[key]; }),
            onchange: function (e) {
                var target = e.target;
                var content = target.options[target.selectedIndex].value;
                onSelect(content === 'none' ? undefined : content);
            },
            size: 'xs'
        });
    };
    return ContentSelect;
}());
exports.ContentSelect = ContentSelect;
function renderContent(contentType, icon) {
    if (contentType === 'Icon') {
        return (0, mithril_1.default)(__1.Icon, { name: icon });
    }
    if (contentType === 'Button') {
        return (0, mithril_1.default)(__1.Button, { label: 'Button' });
    }
    if (contentType === 'Spinner') {
        return (0, mithril_1.default)(__1.Spinner, { active: true });
    }
    if (contentType === 'Tag') {
        return (0, mithril_1.default)(__1.Tag, { label: 'Tag' });
    }
    if (contentType === 'none') {
        return undefined;
    }
}
exports.renderContent = renderContent;
